export const budget = [
  {
    id: 0,
    name: "30-50万",
  },
  {
    id: 1,
    name: "50-70万",
  },
  {
    id: 2,
    name: "70万以上",
  },
];
